import React from 'react';
import { motion } from 'framer-motion';
import { ShieldCheck, Lock, Mail, Zap, Users, CheckCircle2 } from 'lucide-react';
export function AntiScamSection() {
  const pillars = [{
    icon: <Lock className="w-8 h-8 text-[#00f0ff]" data-id="element-46" />,
    title: 'Pagos 100% Seguros',
    desc: 'Tus pagos son procesados por Mercado Pago con cifrado de nivel bancario. Nosotros nunca vemos ni guardamos tus datos de tarjeta.',
    color: 'border-[#00f0ff]/30',
    bg: 'bg-[#00f0ff]/5'
  }, {
    icon: <Zap className="w-8 h-8 text-[#ec4899]" data-id="element-47" />,
    title: 'Entrega Inmediata',
    desc: 'El sistema es automático. Ni bien se acredita tu pago, recibís un email con el acceso a la plataforma para empezar hoy mismo.',
    color: 'border-[#ec4899]/30',
    bg: 'bg-[#ec4899]/5'
  }, {
    icon: <ShieldCheck className="w-8 h-8 text-[#8b5cf6]" data-id="element-48" />,
    title: 'Garantía de 7 Días',
    desc: 'Si el contenido no es lo que esperabas, tenés una semana para pedir el reembolso total. Tu inversión está protegida por ley.',
    color: 'border-[#8b5cf6]/30',
    bg: 'bg-[#8b5cf6]/5'
  }, {
    icon: <Mail className="w-8 h-8 text-[#00f0ff]" data-id="element-49" />,
    title: 'Soporte Humano',
    desc: 'No somos un bot. Tenemos un equipo real respondiendo tus dudas por email y WhatsApp para que nunca te sientas solo.',
    color: 'border-[#00f0ff]/30',
    bg: 'bg-[#00f0ff]/5'
  }];
  return <section className="py-24 px-4 bg-transparent relative overflow-hidden pt-[9px] pb-[9px]" data-id="element-50">
      {/* Decorative background elements */}
      <div className="absolute top-0 left-1/2 -translate-x-1/2 w-full h-full bg-gradient-to-b from-[#1a0b2e]/20 to-transparent pointer-events-none" data-id="element-51" />

      <div className="max-w-6xl mx-auto relative z-10" data-id="element-52">
        <div className="text-center mb-16" data-id="element-53">
          <motion.div initial={{
          opacity: 0,
          scale: 0.9
        }} whileInView={{
          opacity: 1,
          scale: 1
        }} viewport={{
          once: true
        }} className="inline-flex items-center gap-2 px-4 py-1.5 rounded-full bg-red-500/10 border border-red-500/30 text-red-400 text-sm font-black mb-6 tracking-widest uppercase" data-id="element-54">
            <ShieldCheck className="w-4 h-4" data-id="element-55" />
            Tu seguridad es nuestra prioridad
          </motion.div>

          <motion.h2 initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} className="text-4xl md:text-6xl font-black text-white mb-6 tracking-tight leading-tight" data-id="element-56">
            ¿POR QUÉ <span className="text-[#00f0ff]" data-id="element-57">NO SOMOS</span> UNA
            ESTAFA?
          </motion.h2>

          <motion.p initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} className="text-xl text-gray-400 max-w-3xl mx-auto font-medium" data-id="element-58">
            Sabemos que hay mucha desconfianza en internet. Por eso, queremos
            ser 100% transparentes con vos antes de que tomes cualquier
            decisión.
          </motion.p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-6 mb-16" data-id="element-59">
          {pillars.map((pillar, index) => <motion.div key={index} initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          delay: index * 0.1
        }} className={`p-8 rounded-[2.5rem] border ${pillar.color} ${pillar.bg} backdrop-blur-sm hover:scale-[1.02] transition-transform duration-300`} data-id="element-60">
              <div className="flex items-start gap-6" data-id="element-61">
                <div className="p-4 rounded-2xl bg-[#1a0b2e]/50 border border-white/5 shadow-xl" data-id="element-62">
                  {pillar.icon}
                </div>
                <div data-id="element-63">
                  <h3 className="text-2xl font-black text-white mb-3 tracking-tight" data-id="element-64">
                    {pillar.title}
                  </h3>
                  <p className="text-gray-400 leading-relaxed font-medium" data-id="element-65">
                    {pillar.desc}
                  </p>
                </div>
              </div>
            </motion.div>)}
        </div>

        {/* Social Proof Bar */}
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} className="bg-[#1a0b2e]/60 border border-white/5 rounded-[3rem] p-8 md:p-12 flex flex-col md:flex-row text-center md:text-left pt-[0px] pb-[0px] gap-[0px] items-start justify-center" data-id="element-66">
          <div className="flex items-center gap-4" data-id="element-67">
            <div className="w-16 h-16 rounded-full bg-[#00f0ff]/10 flex items-center justify-center" data-id="element-68">
              <Users className="w-8 h-8 text-[#00f0ff]" data-id="element-69" />
            </div>
            <div data-id="element-70">
              <p className="text-3xl font-black text-white" data-id="element-71">+1,500</p>
              <p className="text-gray-400 font-bold uppercase text-xs tracking-widest" data-id="element-72">
                Alumnos Activos
              </p>
            </div>
          </div>

          <div className="h-px w-full md:h-12 md:w-px bg-white/10" data-id="element-73" />

          <div className="flex items-center gap-4" data-id="element-74">
            <div className="w-16 h-16 rounded-full bg-[#ec4899]/10 flex flex-row items-center justify-center" data-id="element-75">
              <CheckCircle2 className="w-8 h-8 text-[#ec4899]" data-id="element-76" />
            </div>
            <div data-id="element-77">
              <p className="text-3xl font-black text-white" data-id="element-78">100%</p>
              <p className="text-gray-400 font-bold uppercase text-xs tracking-widest" data-id="element-79">
                Legal y Transparente
              </p>
            </div>
          </div>

          <div className="h-px w-full md:h-12 md:w-px bg-white/10" data-id="element-80" />

          <div className="flex items-center gap-4" data-id="element-81">
            <div className="w-16 h-16 rounded-full bg-[#8b5cf6]/10 flex items-center justify-center" data-id="element-82">
              <ShieldCheck className="w-8 h-8 text-[#8b5cf6]" data-id="element-83" />
            </div>
            <div data-id="element-84">
              <p className="text-3xl font-black text-white" data-id="element-85">7 DÍAS</p>
              <p className="text-gray-400 font-bold uppercase text-xs tracking-widest" data-id="element-86">
                Garantía Total
              </p>
            </div>
          </div>
        </motion.div>

        <motion.p initial={{
        opacity: 0
      }} whileInView={{
        opacity: 1
      }} viewport={{
        once: true
      }} transition={{
        delay: 0.5
      }} className="text-center mt-12 text-gray-500 text-sm font-medium italic" data-id="element-87">
          * Neon Flex Academy es una marca registrada. Todos los derechos
          reservados.
        </motion.p>
      </div>
    </section>;
}